import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=e0d0c064&scoped=true"
import script from "./footer.vue?vue&type=script&lang=ts"
export * from "./footer.vue?vue&type=script&lang=ts"
import style0 from "./footer.vue?vue&type=style&index=0&id=e0d0c064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d0c064",
  null
  
)

export default component.exports